import { render } from "./candidate-result-row.vue?vue&type=template&id=4ba670f0&scoped=true"
import script from "./candidate-result-row.vue?vue&type=script&lang=js"
export * from "./candidate-result-row.vue?vue&type=script&lang=js"

import "./candidate-result-row.vue?vue&type=style&index=0&id=4ba670f0&scoped=true&lang=css"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba670f0"]])

export default __exports__